module.exports = __webpack_public_path__ + "static/todomvc.425a1da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/examples/todomvc.png
// module id = 2538
// module chunks = 47137193634504